/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".verification-action[_ngcontent-%COMP%]{margin-top:20px}h1[_ngcontent-%COMP%]{margin-bottom:25px;text-align:center}"];
export { styles as styles };
